<template>
    <div>
        <a-modal
            title="关注系统"
            :visible="modalState.isShow"
            width="580px"
            @cancel="handleCancel"
        >
            <a-checkbox  :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange" style="margin-left:10px;margin-bottom:8px;">
            全选
            </a-checkbox>
            <div>
                <a-spin :spinning="spinning" />
                  <template v-for="tag in modalState.syslist">
                    <a-checkable-tag
                        :key="tag"
                        :checked="selectedTags.indexOf(tag) > -1"
                        @change="checked => handleChange(tag, checked)"
                        style="padding:2px 8px;border:1px solid lightgray;margin:4px 8px;font-size:16px;cursor:pointer;width:150px;text-align:center;"
                    >
                        {{ tag }}
                    </a-checkable-tag>
                </template>
            </div>
            
            <template slot="footer">
                <a-button key="back" @click="handleCancel">
                    取消
                </a-button>
                <a-button key="submit" type="primary" @click="handleOk">
                    确定
                </a-button>
            </template>
        </a-modal>
    </div>

</template>
<script>


export default {
    data() {
        return {
            spinning:false,
            selectedTags: [],
            checkAll: false,
            indeterminate: true,
        }
    },
    computed: {
       
    },
    props: {
        modalState: {
            isShow: false,
            syslist:[],
            listfolows:[],
        }
    },
    methods: {
        onCheckAllChange(e) {
            let that = this;
            Object.assign(this, {
                selectedTags: e.target.checked ? that.modalState.syslist : [],
                indeterminate: false,
                checkAll: e.target.checked,
            });
        },
        handleChange(tag, checked) {
            const { selectedTags } = this;
            
            const nextSelectedTags = checked
                ? [...selectedTags, tag]
                : selectedTags.filter(t => t !== tag);
            this.selectedTags = nextSelectedTags;

            this.indeterminate = !!nextSelectedTags.length && nextSelectedTags.length < this.modalState.syslist.length;
            this.checkAll = nextSelectedTags.length === this.modalState.syslist.length;
        },

        handleOk() {

            let that = this;
            that.spinning = true;
            if(that.selectedTags.length > 20){
                that.message.error('关注系统不能超过20个')
                return;
            }
            let params = {
                folowtype:'appcode',
                syslist:that.selectedTags.join(','),
                urlparams:false
            };
            that.$store.dispatch({
                type: "logservice/updatefolow",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == 1){
                    that.handleCancel();
                }
                that.spinning = false;

            }).catch(() => {
                that.spinning = false;

            });
        },
        handleCancel() {
            this.$emit('onModalHide', this.selectedTags);
        }
    },
    mounted() {
    },
    watch: {
        'modalState.isShow'(newVal) {
            if (newVal) {
                this.selectedTags = this.modalState.listfolows
            }
        }
    }
 
};
</script>

<style scoped>
.ant-form-inline .ant-form-item {
    margin-right: 40px;
}
</style>
